import channexhelpers from '~/lib/channexhelpers'
import componenttypes from '~/lib/componenttypes'
import currencies from '~/lib/currencies'
import paymentTypes from '~/lib/paymenttypes'
import reportTypes from '~/lib/reporttypes'
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'

// Tabulator formatters return HTML, so text that customers or merchants typed must be escaped
const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))

export default {
  computed: {
    ...mapGetters(['allSettings', 'locale', 'shopId', 'dateFormat', 'timeFormat', 'numberFormat']),
    shopDeliveryMethods () {
      let ret = {}
      for (let shopIdLocale in this.allSettings) {
        const [shopId, locale] = shopIdLocale.split('-')
        if (locale === this.locale) {
          ret[shopId] = this.allSettings[shopIdLocale].sharedDeliverymethod
        }
      }
      return ret
    },
  },
  mixins: [channexhelpers, componenttypes, currencies, paymentTypes, reportTypes],
  methods: {
    // This is WIP: enables the user to enable/disable columns to view
    headerMenu(optionsVar) {
      const $this = this
      return function() {
        const tableOptions = $this[optionsVar]
        const table = this
        let menu = []
        let columns = tableOptions.columns // this.getColumns()
        let i = 0
        for (let columnDefinition of columns) {
          if (i++ === 0) {
            continue;
          }
          let column = this.getColumn(columnDefinition.field)
          let icon = document.createElement('i')
          icon.classList.add('fa')
          icon.classList.add(column ? 'fa-check-square' : 'fa-square')
          let label = document.createElement('span')
          let title = document.createElement('span')
          title.textContent = ' ' + columnDefinition.title
          label.appendChild(icon)
          label.appendChild(title)
          menu.push({
            label,
            action (e) {
              e.stopPropagation()
              if (icon.classList.contains('fa-check-square')) {
                column.delete()
                icon.classList.remove('fa-check-square')
                icon.classList.add('fa-square')
              } else {
                table.addColumn(columnDefinition, false)
                icon.classList.remove('fa-square')
                icon.classList.add('fa-check-square')
              }
            }
          })
        }
        return menu
      }
    },
    collapseFormatter () {
      return (data) => {
        let list = document.createElement('div')
        list.classList.add('wrapped-row')
        data.forEach((col) => {
          let title = document.createElement('span')
          title.classList.add('wrapped-item-title')
          title.innerHTML = col.title
          let value = document.createElement('span')
          value.classList.add('wrapped-item-value')
          value.innerHTML = col.value
          list.appendChild(title)
          list.appendChild(value)
        })
        return Object.keys(data).length ? list : ''
      }
    },
    orderRowFormatter () {
      return (row) => {
        const full = row.getData()
        if (!parseInt(full.paid) && full.payment !== 'adminnone' && full.payment !== 'open' && parseInt(full.confirmed) !== 1 && parseInt(full.confirmed) !== 3 && parseInt(full.confirmed) !== 5) {
          row.getElement().classList.add('danger')
        } else {
          row.getElement().classList.remove('danger')
        }
        if (full.payment === 'open' && parseInt(full.confirmed) !== 1 && parseInt(full.confirmed) !== 5) {
          row.getElement().classList.add('info')
        } else {
          row.getElement().classList.remove('info')
        }
        if (parseInt(full.confirmed) === 1) {
          row.getElement().classList.add('warning')
        } else {
          row.getElement().classList.remove('warning')
        }
        if (this.type === 'withmore') {
          const idCellWidth = row.getCell('id')?.getElement()?.offsetWidth || 100
          const padding = 8
          const container = document.createElement('div')
          const span = document.createElement('span')
          // Plain text: line breaks stay, markup from the order is not run
          span.textContent = String(full.more ?? '').replace(/<br\s*\/?>/gi, '\n')
          span.style.whiteSpace = 'pre-line'
          container.appendChild(span)
          container.style.paddingTop = '0px'
          container.style.paddingLeft = (idCellWidth + padding) + 'px'
          container.style.marginBottom = '8px'
          container.style.fontSize = '14px'
          row.getElement().appendChild(container)
        }
      }
    },
    maccsboxRowFormatter () {
      return (row) => {
        const full = row.getData()
        if (parseInt(full.code) === -91) {
          row.getElement().classList.add('warning')
        } else {
          row.getElement().classList.remove('warning')
        }
        if (parseInt(full.code) < 1 && parseInt(full.code) !== -91) {
          row.getElement().classList.add('danger')
        } else {
          row.getElement().classList.remove('danger')
        }
        if (parseInt(full.code) === 1) {
          row.getElement().classList.add('success')
        } else {
          row.getElement().classList.remove('success')
        }
      }
    },
    productRowFormatter () {
      return async (row) => {
        const data = row.getData()
        if (!data) {
          return
        }
        const rowElem = row.getElement()
        if (data.itemtype === 'externalproduct') {
          rowElem.classList.add('active')
        }
        rowElem.classList.add('row-' + data.itemtype)
        let categoryOpen = false
        const isExpanded = row.isTreeExpanded()
        if (data.itemtype === 'category') {
          if (isExpanded) {
            rowElem.classList.remove('category-closed')
            rowElem.classList.add('category-open')
            categoryOpen = true
          } else {
            rowElem.classList.remove('category-open')
            rowElem.classList.add('category-closed')
          }
        }
        const descriptionText = (data.itemtype === 'category') ? '' : data.description?.replace(/<\/(div|p|h[1-6]|li|blockquote|pre)>/gi, ' ').replace(/<[^>]+>/g, '').trim()
        if(!descriptionText && !categoryOpen) {
          return
        }
        if(rowElem.lastChild.classList.contains('row-details-container')) {
          return
        }
        const container = document.createElement('div')
        container.classList.add('row-details-container')
        const elem = document.createElement('div')
        elem.classList.add('row-details', 'small')
        if(categoryOpen) {
          elem.innerHTML = '<button class="edit-category btn btn-xs btn-default"><i class="fa fa-fw fa-pen"></i>' + this._('Edit category') + '</button>'
        } else {
          elem.innerHTML = descriptionText
        }
        container.appendChild(elem)
        container.classList.add(data.itemtype)
        if (data.itemtype === 'externalproduct') {
          rowElem.classList.add('active')
        }
        // We seem to need to call this because otherwise the rowElem.classList does not YET contain the tabulator-tree-level-X classes in the current version of Tabulator
        rowElem.appendChild(container)
        await nextTick()
        if (rowElem.classList.contains('tabulator-tree-level-1')) {
          container.classList.add('tree-level-1')
        }
        if (rowElem.classList.contains('tabulator-tree-level-0')) {
          container.classList.add('tree-level-0')
        }
        if (rowElem.classList.contains('tabulator-tree-level-2')) {
          container.classList.add('tree-level-2')
        }
      }
    },
    smartdeviceactionRowFormatter () {
      return (row) => {
        const full = row.getData()
        if (full.error) {
          row.getElement().classList.add('danger')
        } else {
          row.getElement().classList.remove('danger')
        }
        if (DateTime.fromSeconds(Number(full.start_ts), { zone: this.timezone }) > DateTime.now({ zone: this.timezone })) {
          row.getElement().classList.add('info')
        } else {
          row.getElement().classList.remove('info')
        }
      }
    },
    deliveryMethodFormatter () {
      return (cell) => {
        let val = parseInt(cell.getValue(), 10)
        if (!val) {
          const row = cell.getRow()
          const full = row.getData()
          if (!full.deliveries) {
            return ''
          }
          const deliveries = full.deliveries.split(',')
          if (deliveries.length > 1) {
            return this._('Multiple')
          } else {
            val = parseInt(deliveries, 10)
          }
        }
        if (this.shopDeliveryMethods[this.shopId]) {
          for (let i = 0; i < this.shopDeliveryMethods[this.shopId].length; i++) {
            if (parseInt(this.shopDeliveryMethods[this.shopId][i].id, 10) === val) {
              return this.shopDeliveryMethods[this.shopId][i].name
            }
          }
        }
        return ''
      }
    },
    paidFormatter () {
      return (cell) => {
        const val = parseInt(cell.getValue())
        if (val === 1) {
          return this._('Paid')
        } else {
          return this._('Not paid')
        }
      }
    },
    yesNoFormatter () {
      return (cell) => {
        const val = parseInt(cell.getValue())
        if (val === 1) {
          return this._('Yes')
        } else {
          return this._('No')
        }
      }
    },
    processedFormatter () {
      return (cell) => {
        const val = parseInt(cell.getValue())
        if (val === 1) {
          return this._('Processed')
        } else {
          return this._('Not processed')
        }
      }
    },
    reportTypeFormatter () {
      const $this = this
      return (cell) => {
        const reportTypes = $this.allReportTypes
        const format = cell.getValue()
        // We need this exception because this report type is not enabled unless the feature flag is set
        if (format === 'accommodationstatistics') {
          return this._('Accommodation statistics for Statistics Finland')
        }
        for (let i = 0; i < reportTypes.length; i++) {
          if (reportTypes[i].id === format) {
            return reportTypes[i].name
          }
        }
        return format
      }
    },
    timestampFormatter (format) {
      return (cell) => {
        if (!cell.getValue()) {
          return ''
        }
        return DateTime.fromSeconds(Number(cell.getValue()), { zone: this.timezone }).toFormat(format)
      }
    },
    productNameFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const row = cell.getRow()
        const full = row.getData()
        const rowElem = row.getElement()
        if (full.type === 'category') {
          let prefix = ''
          prefix =  '<i class="fa fa-fw fa-folder-closed tabulator-icon"></i><i class="fa fa-fw fa-folder-open tabulator-icon"></i>'
          return prefix + ' <strong>' + val + '</strong>'
        }
        const fullType = full.type + '-' + full.subtype + '-' + full.displayedtype


        let prefix = '<i class="fa fa-fw fa-document tabulator-icon icon-type-' + full.type + ' icon-subtype-' + full.subtype + ' icon-displayedtype-' + full.displayedtype + '"></i> '
        if (full.itemtype === 'product' && fullType !== '0-5-generic' && fullType !== '0-8-generic') {
          prefix = '<button class="btn btn-xs btn-success buy-product tabulator-icon" style="line-height: 10px; margin-top: -5px; margin-bottom: -5px"><i class="fa fa-fw fa-cart-plus"></i></button> '
        }
        return prefix + '<span class="tabulator-product-name">' + val + '</span>' + (full.scheduledtasks ? '&nbsp;<i class="fa fa-fw fa-clock"></i>' : '') 
      }
    },
    resourceNameFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const row = cell.getRow()
        const full = row.getData()
        if (full.itemtype === 'resourcepool' || full.itemtype === 'subresourcepool') {
          return '<i class="fa fa-fw fa-sitemap"></i> <strong>' + val + '</strong>'
        }
        return '<i class="fa fa-fw"></i> ' + val
      }
    },
    productTypeFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const _ = this._
        if (val === 'category') {
          return _('Category')
        }
        const row = cell.getRow()
        const full = row.getData()
        const fullType = val + '-' + full.subtype + '-' + full.displayedtype
        switch(fullType) {
          case '0-0-generic':
            return _('Buyable')
          case '0-5-generic':
            return _('Ticket')
          case '0-6-generic':
            return _('Value card')
          case '0-7-generic':
            return _('Exchanged value card')
          case '0-8-generic':
            return _('Content')
          case '1-0-generic':
            return _('Reservable')
          case '1-1-generic':
            return _('Reservable cabin')
          case '1-2-generic':
            return _('Activity')
          case '1-3-generic':
            return _('Transportation')
          case '1-1000-generic':
            return _('External')
          case '1-1001-generic':
            return _('Hotellinx')
          case '1-1-hotelroom':
            return _('Hotel room')
          case '1-1-cottage':
            return _('Cottage')
          case '1-1-villa':
            return _('Villa')
          case '1-1-otheraccommodation':
            return _('Other accommodation')
          case '1-0-rentalgear':
            return _('Rental gear')
          case '1-0-rentalequipment':
            return _('Rental equipment')
          case '1-2-ticket':
            return _('Ticket')
          case '1-0-meetingvenue':
            return _('Meeting venue')
          case '1-0-partyvenue':
            return _('Party venue')
          case '1-0-othervenue':
            return _('Other venue')
          case '1-2-reservableservice':
            return _('Reservable service')
          case '1-2-eventsservice':
            return _('Events service')
          case '1-2-trip':
            return _('Trip')
          case '1-2-guidedtrip':
            return _('Guided trip')
          case '1-4-generic':
            return _('Event')
          case '1-4-movie':
            return _('Movie')
          case '1-4-theater':
            return _('Theater')
          case '1-4-concert':
            return _('Concert')
          case '1-4-opera':
            return _('Opera')
          case '1-4-ballet':
            return _('Ballet')
        }
        switch (val) {
          case '0':
            return _('Buyable')
          case '1':
            return _('Reservable')
        }
        return val
      }
    },
    resourceTypeFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const _ = this._
        switch (val) {
          case 'generic':
            return _('Resource')
          case 'cottage':
            return _('Cottage')
          case 'villa':
            return _('Villa')
          case 'accommodation':
            return _('Accommodation')
          case 'room':
            return _('Room')
          case 'meetingroom':
            return _('Meeting room')
          case 'space':
            return _('Space')
          case 'theater':
            return _('Theater')
          case 'vehicle':
            return _('Vehicle')
          case 'rentalgear':
            return _('Rental gear')
          case 'rentalequipment':
            return _('Rental equipment')
          case 'guide':
            return _('Guide')
          case 'resourcepool':
            return _('Resource pool')
          case 'buyable':
            return _('Buyable')
          case 'openinghours':
            return _('Opening hours')
          default:
            return _('Unknown')
        }
      }
    },
    tagTypeFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const _ = this._
        switch (val) {
          case 'order':
            return _('Order')
          case 'product':
            return _('Product')
          case 'category':
            return _('Category')
          case 'admin':
            return _('Admin')
          case 'seo':
            return _('SEO')
          case 'delivery':
            return _('Delivery method')
        }
        return val
      }
    },
    tagLanguageFormatter () {
      return (cell) => {
        const val = cell.getValue()
        switch (val) {
          case 'fi_FI':
            return 'suomeksi'
          case 'en_US':
            return 'in English'
          case 'ru_RU':
            return 'по-русски'
          case 'sv_SE':
            return 'på svenska'
          case 'de_DE':
            return 'auf Deutsch'
          case 'it_IT':
            return 'in italiano'
          case 'fr_FR':
            return 'en français'
          case 'es_ES':
            return 'en español'
          case 'nb_NO':
            return 'på norsk'
        }
        return ''
      }
    },
    resourceCapacityFormatter() {
      return (cell) => {
        const val = cell.getValue()
        const _ = this._
        const row = cell.getRow()
        const full = row.getData()
        if (val === null || val === undefined) {
          return val
        }
        const lockIcon = full.seatmap_id ? ' <i class="fa fa-fw fa-lock text-muted" title="' + _('This resource has a seat map, so its capacity is determined automatically by the number of seats drawn in the seat map editor.') + '"></i>' : ''
        if (full.displayedtype === 'buyable') {
          switch (full.unit) {
            case 'pcs':
              return val + ' ' + this._(full.unit) + lockIcon
            case 'm2':
              return val + ' m&#178;' + lockIcon
            case 'm3':
              return val + ' m&#179;' + lockIcon
            default:
              return val + ' ' + full.unit + lockIcon
          }
        }
        return val + lockIcon
      }
    },
    contentTypeFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const _ = this._
        return val
      }
    },
    notificationStatusFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const _ = this._
        const icon = '&nbsp;<i class="fa fa-refresh resetbutton" style="cursor: pointer"></i>'
        switch (parseInt(val, 10)) {
          case 0:
            return _('Not sent')
          case 1:
            return _('Sent') + icon
          case 2:
            return _('Send failed') + icon
          case 3:
            return _('Not paid') + icon
          case 4:
            return _('Skipped') + icon
          case 5:
            return _('SMS service disabled') + icon
          case 6:
            return _('No PIN found') + icon
          case 7:
            return _('No reservation found') + icon
          case 8:
            return _('Not confirmed') + icon
          case 9:
            return _('No checkin/checkout') + icon
          case 10:
            return _('Processing') + icon
          }
        return val
      }
    },
    discountTypeFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const _ = this._
        switch (parseInt(val, 10)) {
          case 0:
            return _('Order-level')
          case 1:
            return _('Product-level')
          case 2:
            return _('Product-level') + ' (x)'
        }
        return val
      }
    },
    discountUnitFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const _ = this._
        let symbol = '&euro;'
        if (this.settings && this.settings.currency) {
          symbol = this.currencySymbol(this.settings.currency)
        }
        switch (parseInt(val, 10)) {
          case 0:
            return '%'
          case 1:
            return symbol
        }
        return val
      }
    },
    discountUsageFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const _ = this._
        switch (parseInt(val, 10)) {
          case 2:
            return _('Multi use')
          case 1:
            return _('Single use')
          case 0:
          default:
            return _('Permanent')
        }
      }
    },
    orderCustomerFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const l = 30
        let out
        const row = cell.getRow()
        const full = row.getData()
        const _ = this._
        if (!val) {
          if (full.pos_name) {
            out = String(full.pos_name)
          } else {
            return '<i>' + _('Transaction incomplete') + '</i>'
          }
        } else {
          out = val
        }
        if (full.billing_company && out != full.billing_company) {
          out += ' / ' + full.billing_company
        }
        let ret = out
        if (out.length > l) {
          ret = out.substr(0, l) + '...'
        } 
        ret = escapeHtml(ret)
        if (parseInt(full.grouped, 10) === 1) {
          ret = '<i class="fa fa-fw fa-folder-open"></i> ' + ret
        } else if (parseInt(full.grouped, 10) === -1) {
          ret = '<i class="fa fa-fw fa-share"></i> ' + ret
        }
        return ret
      }
    },
    orderPaidFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const row = cell.getRow()
        const full = row.getData()
        const _ = this._
        let ret = _('Unknown').replace(' ', '&nbsp;')  // This functionality is copy-pasted to OrderDetails.vue... maybe these could be unified at some point, but it's Friday again
        switch (parseInt(val)) {
          case 0:
            ret = _('Unpaid')
            if (parseInt(full.groupdeal)) { // group deal
              ret += '&nbsp;(' + _('Group') + ')'
            }
            if (parseInt(full.confirmed) === 1) {
              ret = _('Confirmed')
            } else if(parseInt(full.confirmed) === 2) {
              ret = _('Unpaid')
            } else if(parseInt(full.confirmed) === 3) {
              ret = _('Billed')
            } else if(parseInt(full.confirmed) === 5) {
              ret = _('Payment plan').replace(' ', '&nbsp;')
            } else if(!parseInt(full.completed)) {
              const ignore = ['bill', 'open', 'transfer', 'cash', 'admincash', 'admincard', 'adminnone', 'multi', 'voucher', 'none']
              if (full.payment && !ignore.includes(full.payment)) {
                ret = _('Transaction incomplete')
              }
            }
            ret = ret.replace(' ', '&nbsp;')
            if (parseInt(full.paymentlinksent)) {
              ret += '&nbsp;<i class="fa fa-fw fa-send"></i>'
            }
            if (parseInt(full.confirmationlinksent)) {
              ret += '&nbsp;<i class="fa fa-fw fa-check-square-o"></i>'
            }
            break
          case 1:
            ret = _('Paid').replace(' ', '&nbsp;')
            break
          case 2:
            ret = _('No charge').replace(' ', '&nbsp;')
            break
        }
        if (parseInt(full.refunded)) { // refunded
          ret = _('Refunded').replace(' ', '&nbsp;')
        }
        if (full.payment === 'adminnone') {
          ret = _('No charge').replace(' ', '&nbsp;')
        }
        if (parseInt(full.confirmed) === 5) {
          ret += '&nbsp;<i class="fa fa-fw fa-calendar-check"></i>'
        }
       if (full.more) {
          ret += '&nbsp;<i class="fa fa-fw fa-sticky-note"></i>'
        }
        return ret
      }
    },
    paymentPlanTypeFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const _ = this._
        switch (val) {
          case 'advance':
            return _('Advance payment')
          case 'recurring':
            return _('Recurring payment')
        }
        return val
      }
    },
    paymentFormatter () {
      return (cell) => {
        const val = cell.getValue()
        return this.getPaymentTitle(val)
      }
    },
    floatingFormatter () {
      return (cell) => {
        const val = parseInt(cell.getValue())
        if (val === 1) {
          return '<i class="fa fa-fw"></i> ' + this._('Floating')
        } else {
          return '<i class="fa fa-fw fa-link"></i> ' + this._('Fixed')
        }
      }
    },
    issueTypeFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const _ = this._
        switch (val) {
          case 'netvisor':
            return _('Netvisor')
          case 'ropo':
            return _('Ropo')
          case 'email':
            return _('Email')
          case 'report':
            return _('Report')
          case 'generic':
            return _('Generic')
          case 'backgroundtask':
            return _('Background task')
          case 'seam':
            return _('Seam')
          case 'payment':
            return _('Payment')
        }
        return val
      }
    },
    issueStatusFormatter () {
      return (cell) => {
        const val = parseInt(cell.getValue())
        if (val === 1) {
          return this._('Acknowledged')
        } else {
          return this._('Not acknowledged')
        }
      }
    },
    userinterfaceNameFormatter (clientIdFunc) {
      return (cell) => {
        let currentClientId = null
        if (clientIdFunc && typeof clientIdFunc === 'function') {
          currentClientId = clientIdFunc()
        }
        const val = cell.getValue()
        const row = cell.getRow()
        const full = row.getData()
        if (currentClientId && currentClientId === full.identifier) {
          return '<strong>' + val + ' (' + this._('Active') + ')</strong>'
        }
        return val
      }
    },
    pointOfUseNameFormatter (pointOfUseIdFunc) {
      return (cell) => {
        let currentPointOfUse = null
        if (pointOfUseIdFunc && typeof pointOfUseIdFunc === 'function') {
          currentPointOfUse = pointOfUseIdFunc()
        }
        const val = cell.getValue()
        const row = cell.getRow()
        const full = row.getData()
        if (currentPointOfUse && currentPointOfUse === full.id) {
          return '<strong>' + val + ' (' + this._('Active') + ')</strong>'
        }
        return val
      }
    },
    layoutNameFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const row = cell.getRow()
        const full = row.getData()
        const data = JSON.parse(full.data)
        if (data && data.icon && /^[a-z0-9-]+$/.test(data.icon)) {
          return '<i class="fa fa-fw fa-' + data.icon+ '"></i> ' + escapeHtml(val)
        }
        return '<i class="fa fa-fw"></i> ' + escapeHtml(val)
      }
    },
    templateTypeFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const _ = this._
        switch (val) {
          case 'posreceipt.tpl':
            return _('POS receipt')
          case 'posticket.tpl':
            return _('POS ticket')
          case 'bocaticket.tpl':
            return _('POS ticket') + ' (BOCA)'
          case 'pdfvaluecard.tpl':
            return _('PDF value card')
        }
        return val
      }
    },
    widgetTypeFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const _ = this._
        if (val === 'ProductCard') {
          return _('Product card')
        }
        if (val === 'JoinChannel') {
          return _('Join sales channel')
        }
        if (val === 'Login') {
          return _('Login')
        }
        if (val === 'Account') {
          return _('Account')
        }
        return _(val)
      }
    },
    componentTypeFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const name = this.getComponentName(val)
        if (name) {
          return val + ' (' + name + ')'
        }
        return val
      }
    },
    shopIdListFormatter () {
      return (cell) => {
        const val = cell.getValue()
        if (!val) {
          return ''
        }
        const ids = val.split(',').sort((a, b) => a > b ? 1 : -1)
        return ids.map(id => '<span class="label label-' + (id === this.shopId ? 'success' : 'default') + '">' + id + '</span>').join(' ')
      }
    },
    sourceChannelListFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const row = cell.getRow()
        const full = row.getData()
        if (!val) {
          return '<span class="label label-success">' + this.shopId + '</span>'
        }
        if (full.pos_id) {
          if (full.pos_name) {
            return '<span class="label label-info" title="' + escapeHtml(full.pos_name) + '">pos-' + escapeHtml(full.pos_id) + '</span>'
          }
          return '<span class="label label-info">pos-' + full.pos_id + '</span>'
        }
        const ids = val.split(',').sort((a, b) => a > b ? 1 : -1)
        return ids.map(id => '<span class="label label-' + (id === this.shopId ? 'success' : 'default') + '">' + this.formatOrigin(id) + '</span>').join(' ')
      }
    },
    notificationRecipientFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const row = cell.getRow()
        const full = row.getData()
        if (parseInt(full.type) === 1) {
          if (full.custom_numbers) {
            return full.custom_numbers.split(';').join('<br/>')
          }
          return full.phone
        }
        if (full.custom_emails) {
          return full.custom_emails.split(';').join('<br/>')
        }
        return full.email
      }
    },
    shipitPriceFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const row = cell.getRow()
        const full = row.getData()
        if (parseInt(full.shipit_pricing)) {
          return '+' + Intl.NumberFormat(this.numberFormat, { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(full.shipit_margin) + ' %';
        }
        if (!val) {
          return ''
        }
        return Intl.NumberFormat(this.numberFormat, { style: 'currency', currency: this.settings.currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(val)
      }
    },
    deliveryTypeFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const row = cell.getRow()
        const full = row.getData()
        let ret = []
        if (parseInt(val)) {
          ret.push(this._('Internal'))
        }
        if (parseInt(full.default)) {
          ret.push(this._('Default'))
        }
        return ret.join(', ')
      }
    },
    shipmentDimensionsFormatter () {
      return (cell) => {
        const row = cell.getRow()
        const full = row.getData()
        if (full.maxheight && full.maxwidth && full.maxdepth && full.maxweight) {
          return full.maxheight + ' x ' + full.maxwidth + ' x ' + full.maxdepth + ' cm, ' + full.maxweight + ' kg'
        }
        return ''
      }
    },
    tagFormatter () {
      return (cell) => {
        const val = cell.getValue()
        let ret = ''
        if (val && val.length) {
          val.forEach(tag => {
            const [, title] = tag.title.split(':::')
            ret += '<span class="label label-info">' + title + '</span>'
          })
        }
        return ret
      }
    },
    smartDeviceNameFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const row = cell.getRow()
        const full = row.getData()
        let typeIcon = ''
        switch (full.type) {
          case 'lock':
            if (full.subtype === 'seamacs') {
              typeIcon = '<i class="fa fa-fw fa-house-lock"></i> '
            } else {
              typeIcon = '<i class="fa fa-fw fa-lock"></i> '
            }
            break
          case 'temperature':
            typeIcon = '<i class="fa fa-fw fa-temperature-list"></i> '
            break
        }
        return typeIcon + val
      }
    },
    smartDeviceSubtypeFormatter () {
      const transformDisplayedType = (type) => {
        switch (type) {
          case 'akuvox_lock':
            return this._('Akuvox')
          case 'august_lock':
            return this._('August')
          case 'brivo_access_point':
            return this._('Brivo')
          case 'butterflymx_panel':
            return this._('ButterflyMX')
          case 'avigilon_alta_entry':
            return this._('Avigilon')
          case 'doorking_lock':
            return this._('Doorking')
          case 'igloo_lock':
            return this._('Igloohome')
          case 'linear_lock':
            return this._('Linear')
          case 'lockly_lock':
            return this._('Lockly')
          case 'kwikset_lock':
            return this._('Kwikset')
          case 'nuki_lock':
            return this._('Nuki')
          case 'salto_lock':
            return this._('Salto')
          case 'schlage_lock':
            return this._('Schlage')
          case 'seam_relay':
            return this._('Seam relay')
          case 'smartthings_lock':
            return this._('SmartThings')
          case 'wyze_lock':
            return this._('Wyze')
          case 'igloohome_lock':
            return this._('Igloohome')
          case 'hubitat_lock':
            return this._('Hubitat')
          case 'four_suites_door':
            return this._('Four Suites')
          case 'dormakaba_oracode_door':
            return this._('Dormakaba')
          case 'tedee_lock':
            return this._('Tedee')
          case 'akiles_lock':
            return this._('Akiles')
          case 'yale_lock':
            return this._('Yale')
          case 'salto_ks_access_group':
            return this._('Salto KS Access Group')
        }
        return type
      }
      return (cell) => {
        const val = cell.getValue()
        const row = cell.getRow()
        const full = row.getData()
        let dtStr = ''
        switch (val) {
          case 'seam':
            if (full.displayedtype) {
              dtStr = ' / ' + transformDisplayedType(full.displayedtype)
            }
            if (full.origin) {
              return this._('Seam') + dtStr + ' (' + full.origin + ')'
            }
            return this._('Seam') + dtStr
          case 'seamacs':
            if (full.displayedtype) {
              dtStr = ' / ' + transformDisplayedType(full.displayedtype)
            }
            if (full.origin) {
              return this._('Seam ACS') + dtStr + ' (' + full.origin + ')'
            }
            return this._('Seam ACS') + dtStr
          case 'adax':
            return this._('Adax')
          case 'yale':
            return this._('Yale')
          case 'ratna':
            return this._('Ratna')
          case 'igloo':
            return this._('Igloohome')
        }
        return val
      }
    },
    numberFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const row = cell.getRow()
        const full = row.getData()
        if (isNaN(val) || full.subtype === "8" || full.itemtype === "category") {
          return ''
        }
        return Intl.NumberFormat(this.numberFormat, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cell.getValue())
      }
    },
    vatFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const row = cell.getRow()
        const full = row.getData()
        if (val === null || isNaN(val) || full.subtype === "8") {
          return ''
        }
        if (parseInt(val, 10) != parseFloat(val)) {
          return Intl.NumberFormat(this.numberFormat, { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(cell.getValue())
        }
        return val
      }
    },
    dateFormatter () {
      return (cell) => {
        return cell.getValue() ? DateTime.fromSeconds(Number(cell.getValue()), { zone: this.timezone }).toFormat(this.dateFormat) : ''
      }
    },
    timeFormatter () {
      return (cell) => {
        return cell.getValue() ? DateTime.fromSeconds(Number(cell.getValue()), { zone: this.timezone }).toFormat(this.timeFormat) : ''
      }
    },
    dateAndTimeFormatter () {
      return (cell) => {
        return cell.getValue() ? DateTime.fromSeconds(Number(cell.getValue()), { zone: this.timezone }).toFormat(this.dateFormat) + ' ' + this._('at') + ' ' + DateTime.fromSeconds(Number(cell.getValue()), { zone: this.timezone }).toFormat(this.timeFormat) : ''
      }
    },
    taskTypeFormatter (taskTypes) {
      return (cell) => {
        const format = cell.getValue()
        for (let i = 0; i < taskTypes.length; i++) {
          if (taskTypes[i].id === format) {
            return taskTypes[i].name
          }
        }
        return format
      }
    },
    taskActionFormatter () {
      return (cell) => {
        const data = JSON.parse(cell.getValue())
        if (data && data.action) {
          switch (data.action) {
            case 'publish':
              return this._('Publish')
            case 'archive':
              return this._('verb|Archive')
            case 'visibility':
              return this._('verb|Change Storefront visibility')
          }
          return data.action
        }
        return ''
      }
    },
    taskStatusFormatter () {
      return (cell) => {
        const val = cell.getValue()
        switch (parseInt(val)) {
          case 0:
            return this._('Scheduled')
          case 1:
            return this._('Done')
          case 2:
            return this._('Failed')
          default:
            return this._('Processing')
        }
      }
    },
    channexBookingStatusFormatter () {
      return (cell) => {
        const val = cell.getValue()
        switch (val) {
          case 'new':
            cell.getElement().style.color = '#4f792b'
            return '<i class="fa fa-fw fa-calendar-plus"></i> ' + this._('New')
          case 'modified':
            cell.getElement().style.color = '#f28e00'
            return '<i class="fa fa-fw fa-pen-to-square"></i> ' + this._('Modified')
          case 'cancelled':
            cell.getElement().style.color = '#dc3545'
            return '<i class="fa fa-fw fa-calendar-xmark"></i> ' + this._('Cancelled')
        }
      }
    },
    channexOrderIdFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const row = cell.getRow()
        const full = row.getData()
        if (val) {
          return val
        }
        return '<i class="fa fa-fw fa-refresh"></i>'
      }
    },
    channexBookingIdFormatter () {
      return (cell) => {
        const val = cell.getValue()
        const row = cell.getRow()
        const full = row.getData()
        return val + ' <i class="fa fa-fw fa-arrow-up-right-from-square"></i>'
      }
    },
    addProductToBasketFormatter () {
      return (cell) => {
        const row = cell.getRow()
        const full = row.getData()
        const fullType = full.type + '-' + full.subtype + '-' + full.displayedtype
        if (full.itemtype === 'product' && fullType !== '0-5-generic' && fullType !== '0-8-generic') {
          return '<button class="btn btn-xs btn-success" style="line-height: 10px; margin-top: -5px; margin-bottom: -5px"><i class="fa fa-fw fa-cart-plus"></i></button>'
        }
      }
    },
    adminShopStatusFormatter () {
      return (cell) => {
        const row = cell.getRow()
        const shop = row.getData()
        if (parseInt(shop.locked)) {
          return '<i class="fa fa-fw fa-lock"></i> Locked'
        }
        if (parseInt(shop.notified)) {
          return '<i class="fa fa-fw fa-exclamation-triangle"></i> Notified'
        }
        if (!parseInt(shop.enabled)) {
          return '<i class="fa fa-fw fa-ban"></i> Disabled'
        }
        return '<i class="fa fa-fw fa-check"></i> Enabled'
      }
    },
    adminShopFeatureFormatter () {
      return (cell) => {
        const val = cell.getValue()
        if (!val) {
          return ''
        }
        const features = val.split(';')
        return features.map(feature => '<span class="label label-info">' + feature + '</span>').join(' ')
      }
    },
    termsNameFormatter () {
      return (cell) => {
        const val = cell.getValue()
        if (!val) {
          return '<i>' + this._('The language version was not found') + '</i>'
        }
        return val
      }
    },
    mobilepayAttemptTypeFormatter () {
      return (cell) => {
        const val = cell.getValue()
        return val === 'order' ? this._('Order') : this._('POS transaction')
      }
    }
  }
}